module.exports = __webpack_public_path__ + "static/img/JD963774380491.7acc16b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/JD963774380491.png
// module id = 12lc
// module chunks = 1